import { jsx as _jsx } from "react/jsx-runtime";
import { FileStatusButton, FileStatusIconErrored, FileStatusTitle } from "@air/feature-file-status/ui";
import { Close } from "@air/next-icons";
import pluralize from "pluralize";
import { memo } from "react";
import { PaneItemTW } from "~/components/FileStatusTrackingPane/PaneItemTW";
export const ZippingTaskFailedPanelItem = /*#__PURE__*/ memo((param)=>{
    let { metadata: { clipIds = [], boardIds = [] }, onClear } = param;
    return /*#__PURE__*/ _jsx(PaneItemTW, {
        avatar: /*#__PURE__*/ _jsx(FileStatusIconErrored, {}),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            children: "Failed to zip ".concat(pluralize("item", clipIds.length + boardIds.length, true))
        }),
        buttons: /*#__PURE__*/ _jsx(FileStatusButton, {
            label: "Clear",
            onClick: ()=>onClear(),
            children: /*#__PURE__*/ _jsx(Close, {
                className: "size-4"
            })
        })
    });
});
ZippingTaskFailedPanelItem.displayName = "ZippingTaskFailedPanelItem";
